/** Clair / sombre + accent, ou Aurélia+ (palette bleu-violet fixe). localStorage propre au CRM. */
import { ACCENTS, normalizeAccent, type AccentId } from "./accents";

export type CrmTheme = "light" | "dark" | "plus";

const THEME_KEY = "crm_theme";
const ACCENT_KEY = "crm_accent";

export function readCrmTheme(): CrmTheme {
  try {
    const value = localStorage.getItem(THEME_KEY);
    if (value === "light" || value === "dark" || value === "plus") return value;
  } catch {
    /* ignore */
  }
  return "light";
}

export function readCrmAccent(): AccentId {
  try {
    return normalizeAccent(localStorage.getItem(ACCENT_KEY));
  } catch {
    return "indigo";
  }
}

export function applyCrmTheme(theme: CrmTheme, accentId: AccentId): void {
  const accent = ACCENTS[normalizeAccent(accentId)];
  const plus = theme === "plus";
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.classList.toggle("dark", theme === "dark" || plus);
  const soft = theme === "dark" ? accent.accentSoftDark : accent.accentSoft;
  root.style.setProperty("--crm-accent", plus ? "#3b82f6" : accent.accent);
  root.style.setProperty("--crm-accent-strong", plus ? "#c4b5fd" : accent.accentStrong);
  root.style.setProperty("--crm-accent-soft", plus ? "rgb(59 130 246 / 16%)" : soft);
  root.style.setProperty("--crm-swatch", plus ? "#3b82f6" : accent.swatch);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", plus || theme === "dark" ? "#0b1220" : accent.accent);
  try {
    localStorage.setItem(THEME_KEY, theme);
    localStorage.setItem(ACCENT_KEY, accent.id);
  } catch {
    /* ignore */
  }
}

/** Fondu court au changement d’apparence. Pas au chargement. */
export function playCrmThemeFade(): void {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const root = document.documentElement;
  root.classList.remove("crm-theme-swap");
  void root.offsetWidth;
  root.classList.add("crm-theme-swap");
  window.setTimeout(() => root.classList.remove("crm-theme-swap"), 760);
}
